import React from "react";
import SettingsList from "../../components/patient2/settings/SettingsList";

export default function SettingsScreen({
  onProfile,
  onPatientSetup,
  onNotifications,
  onLanguage,
  onLogout,
}) {
  return (
    <div className="p2-settings-root">
      <div className="p2-settings-header">
        <h1 className="p2-settings-title">
          Cilësimet
        </h1>
        <p className="p2-settings-sub">
          Menaxho llogarinë dhe preferencat e tua.
        </p>
      </div>

      <SettingsList
        onProfile={onProfile}
        onPatientSetup={onPatientSetup}
        onNotifications={onNotifications}
        onLanguage={onLanguage}
        onLogout={onLogout}
      />
    </div>
  );
}
